import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../apiconfig";
import logoutUser from "./logoutUser";

function Education({ onNext, onPrev }) {

	const navigate = useNavigate();
	const [alertData, setAlertData] = useState(null);

	const showAlert = (message, type = "error") => {
		setAlertData({
			message,
			type,
			id: Date.now()
		});

		setTimeout(() => {
			setAlertData(null);
		}, 5000); // match your CSS fadeOut timing
	};

	const [selectedProgramcode, setSelectedProgramcode] = useState("");
	useEffect(() => {
		const fetchProgram = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_PROGRAM_CODE`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (!response.ok) return;

				const data = await response.text(); // since backend returns string
				console.log("selected program code is:", data);

				if (data) {
					setSelectedProgramcode(data); // ✅ auto select
				}

			} catch (err) {
				console.error("Failed to fetch program", err);
			}
		};

		fetchProgram();
	}, []);

	const [calculateage, setcalculateage] = useState("");
	useEffect(() => {
		const fetchCalculatedAge = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_CALCULATE_AGE`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (!response.ok) return;

				const data = await response.text(); // since backend returns string
				console.log("calculated age is:", data);

				if (data) {
					setcalculateage(data); // ✅ auto select
				}

			} catch (err) {
				console.error("Failed to fetch age", err);
			}
		};

		fetchCalculatedAge();
	}, []);

	const [category, setcategory] = useState("");
	useEffect(() => {
		const fetchCategory = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_CATEGORY`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (!response.ok) return;

				const data = await response.text(); // since backend returns string
				console.log("category is:", data);

				if (data) {
					setcategory(data); // ✅ auto select
				}

			} catch (err) {
				console.error("Failed to fetch category", err);
			}
		};

		fetchCategory();
	}, []);






	const [educationData, setEducationData] = useState({
		appearingFinalSemester: "",
		exam: "Diploma",
		yearOfPassing: "",
		percentage: "",
		branch: "",
		recognizediplomainstitution: "",
		mathsPassed: "",
		appearingFinalGraduation: "",
		yearOfPassingGraduation: "",
		percentageGraduation: ""
	});



	const handleChange = (e) => {
		const { name, value } = e.target;

		setEducationData((prev) => {

			let updatedData = {
				...prev,
				[name]: value
			};

			// ✅ IF DIPLOMA (02) → YES → CLEAR TABLE
			if (name === "appearingFinalSemester" && value === "YES") {
				updatedData = {
					...updatedData,
					exam: "",
					yearOfPassing: "",
					percentage: ""
				};
			}

			// ✅ IF GRADUATION (01) → YES → CLEAR TABLE
			if (name === "appearingFinalGraduation" && value === "YES") {
				updatedData = {
					...updatedData,
					examGraduation: "",
					yearOfPassingGraduation: "",
					percentageGraduation: ""
				};
			}

			// ✅ IF PROGRAM = 01 → CLEAR ALL 02 DATA
			if (selectedProgramcode === "01" || selectedProgramcode === "1") {
				updatedData = {
					...updatedData,
					appearingFinalSemester: "",
					exam: "",
					yearOfPassing: "",
					percentage: "",
					branch: "",
					recognizediplomainstitution: ""
				};
			}

			// ✅ IF PROGRAM = 02 → CLEAR ALL 01 DATA
			if (selectedProgramcode === "02" || selectedProgramcode === "2") {
				updatedData = {
					...updatedData,
					mathsPassed: "",
					appearingFinalGraduation: "",
					examGraduation: "",
					yearOfPassingGraduation: "",
					percentageGraduation: ""
				};
			}

			return updatedData;
		});
	};

	const handleSubmit = async () => {
		try {
			const token = sessionStorage.getItem("token");
			const programCode = selectedProgramcode?.toString().replace(/^0+/, "");

			// =========================
			// ✅ VALIDATION START
			// =========================

			// 🔥 Apply only for program 2
			if (programCode === "2") {

				if (!educationData.appearingFinalSemester) {
					showAlert("Please select appearing status ❗", "error");
					return;
				}

				if (educationData.appearingFinalSemester === "NO") {

					if (!educationData.yearOfPassing) {
						showAlert("Enter year of passing ❗", "error");
						return;
					}

					if (!/^\d{4}$/.test(educationData.yearOfPassing)) {
						showAlert("Year must be 4 digits (e.g. 2024) ❗", "error");
						return;
					}

					if (!educationData.percentage) {
						showAlert("Enter percentage ❗", "error");
						return;
					}

					const percent = parseFloat(educationData.percentage);

					if (isNaN(percent) || percent < 0 || percent > 100) {
						showAlert("Percentage must be between 0–100 ❗", "error");
						return;
					}
					const percentage = parseFloat(educationData.percentage);

					if (category === "1 - UNRESERVED CATEGORY (UR)") {

						if (percentage < 45) {
							showAlert("Minimum 45% marks required for UNRESERVED CATEGORY (UR)", "error");
							return;
						}

					} else {

						if (percentage < 40) {
							showAlert("Minimum 40% marks required for RESERVED CATEGORY", "error");
							return;
						}
					}
				}

				if (!educationData.branch || educationData.branch === "0") {
					showAlert("Please select branch ❗", "error");
					return;
				}

				if (!educationData.recognizediplomainstitution || educationData.recognizediplomainstitution === "0") {
					showAlert("Please select recognizediplomainstitution ❗", "error");
					return;
				}

				if (educationData.recognizediplomainstitution === "NONE") {
					showAlert("You are not eligible. Only recognized Assam Polytechnic diploma candidates can apply ❗", "error");
					return;
				}


			}

			if ((programCode === "01" || programCode === "1")) {

				const age = parseInt(calculateage);

				if (isNaN(age) || age < 20 || age > 26) {
					showAlert("Age must be between 20 to 26 years for this program.", "error");
					return;
				}

				if (!educationData.mathsPassed) {
					showAlert("Please select whether you have passed Mathematics at 10+2 level or Graduation.", "error");
					return;
				}

				if (educationData.mathsPassed === "NO") {
					showAlert("You are not eligible, Candidate have to passed Mathematics as one of the subjects at 10+2 level or Graduation", "error");
					return;
				}

				if (!educationData.appearingFinalGraduation) {
					showAlert("Please select Graduation appearing status", "error");
					return;
				}


				if (!educationData.yearOfPassingGraduation || !educationData.percentageGraduation) {
					showAlert("Please fill Graduation details", "error");
					return;
				}
				const percentage = parseFloat(educationData.percentageGraduation);

				if (category === "1 - UNRESERVED CATEGORY (UR)") {

					if (percentage < 50) {
						showAlert("Minimum 50% marks required for UNRESERVED CATEGORY (UR)", "error");
						return;
					}

				} else {

					if (percentage < 45) {
						showAlert("Minimum 45% marks required for RESERVED CATEGORY", "error");
						return;
					}
				}

			}

			const response = await fetch(
				`${API_BASE_URL}/API/Student/SAVE_EDUCATION`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"Authorization": "Bearer " + token
					},
					body: JSON.stringify(educationData)
				}
			);

			if (response.ok) {
				showAlert("Education Data Saved successfully", "success");
				console.log("Saved:", educationData);

				setTimeout(() => {
					onNext();
				}, 600);
			} else {
				showAlert("Failed to save");
			}

		} catch (error) {
			console.error(error);
			showAlert("Server error");
		}
	};

	const fetchEducationData = async () => {
		try {
			const token = sessionStorage.getItem("token");

			const res = await fetch(
				`${API_BASE_URL}/API/Student/GET_EDUCATION_DATA`,
				{
					method: "GET",
					headers: {
						Authorization: "Bearer " + token
					}
				}
			);

			if (res.status === 401 || res.status === 403) {

				logoutUser(navigate);
				return;
			}

			if (!res.ok) {
				console.error("Failed to fetch program");
				return;
			}


			const data = await res.json();
			console.log("Education Data:", data);


			if (!res.ok || data === "NOT_FOUND" || data.status === "EDUCATION_NOT_FOUND") {
				return;
			}

			// ✅ SET STATE
			setEducationData({
				appearingFinalSemester: data.appearingFinalSemester || "",
				exam: data.exam || "Diploma",
				yearOfPassing: data.yearOfPassing || "",
				percentage: data.percentage || "",
				branch: data.branch || "",
				recognizediplomainstitution: data.recognizediplomainstitution || "",
				mathsPassed: data.mathsPassed || "",
				appearingFinalGraduation: data.appearingFinalGraduation || "",
				yearOfPassingGraduation: data.yearOfPassingGraduation || "",
				percentageGraduation: data.percentageGraduation || ""
			});

			// 🔥 IMPORTANT (for radio UI)


		} catch (err) {
			console.error("Fetch error:", err);
		}
	};

	useEffect(() => {
		fetchEducationData();
	}, []);

	const [isPaymentDone, setIsPaymentDone] = useState(false);

	useEffect(() => {
		const checkPaymentStatus = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_PAYMENT_DONE_OR_NOT`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (!response.ok) return;

				const result = await response.json(); // boolean true/false
				console.log("Payment Done:", result);

				setIsPaymentDone(result);



			} catch (error) {
				console.error("Error checking payment:", error);
			}
		};

		checkPaymentStatus();
	}, []);
	
	const [isEditOn, setIsEditOn] = useState(false);
	   useEffect(() => {
	       const checkPaymentStatus = async () => {
	           try {
	               const token = sessionStorage.getItem("token");

	               const response = await fetch(
	                   `${API_BASE_URL}/API/Student/EDIT_ON_OFF`,
	                   {
	                       method: "GET",
	                       headers: {
	                           "Authorization": "Bearer " + token
	                       }
	                   }
	               );

	               if (!response.ok) return;

	               const result = await response.json();
	               console.log("edit response:", result);

	               setIsEditOn(result);



	           } catch (error) {
	               console.error("Error checking payment:", error);
	           }
	       };

	       checkPaymentStatus();
	   }, []);

	   //const canEdit = !isPaymentDone || isEditOn === false;

	   const canEdit = isEditOn === false;
	return (
		<div className="container">

			<style>{`
				
		@keyframes smoothEntry {
		0% {
		   opacity: 0;
		   transform: translateY(20px);
	 	  }
		100% {
		   opacity: 1;
		   transform: translateY(0);
		 }
		}

        .container {
          max-width: 900px;
          margin: 25px auto;
          background: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 10px;
          padding: 18px 20px;
          font-family: Arial;
          box-shadow: 0 2px 6px rgba(0,0,0,0.05);
		  animation: smoothEntry 0.4s ease;
        }

        .title {
          font-size: 16px;
          font-weight: 600;
          color: #065f46;
          margin-bottom: 15px;
        }

        .question {
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 10px;
        }

		.radio-group {
		  display: flex;
		  align-items: center;   
		  gap: 25px;
		  margin-bottom: 20px;
		}

		.radio-group label {
		  font-size: 13px;
		  cursor: pointer;
		  display: flex;         
		  align-items: center;   
		  gap: 5px;
		}

		.radio-group input {
		  margin: 0;             
		}

        /* TABLE */
        .table-box {
          margin-top: 10px;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          overflow: hidden;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th {
          background: #f1f5f9;
          font-size: 13px;
          padding: 10px;
          border: 1px solid #e2e8f0;
        }

        td {
          padding: 8px;
          border: 1px solid #e2e8f0;
          text-align: center;
        }

        input {
          width: 95%;
          padding: 6px;
          font-size: 12.5px;
          border: 1px solid #cbd5e1;
          border-radius: 4px;
          outline: none;
        }

        input:focus {
          border-color: #059669;
        }
		.question-row {
		  display: flex;
		  align-items: center;
		  justify-content: space-between;
		  margin-bottom: 15px;
		}

		.question {
		  font-size: 14px;
		  font-weight: bold;
		}

		.radio-group {
		  display: flex;
		  gap: 20px;
		}

		.radio-group label {
		  display: flex;
		  align-items: center;
		  font-size: 13px;
		  cursor: pointer;
		}

		.radio-group input {
		  margin-right: 5px;
		}
		.branch-row {
		  display: flex;
		  align-items: center;
		  gap: 15px;
		  margin-top: 15px;
		  flex-wrap: wrap;   /* ✅ allows dropdown to move below if needed */
		}

		.branch-label {
		  font-size: 13.5px;
		  font-weight: 500;
		  min-width: 260px;
		  font-weight:bold;
		}

		.branch-select {
		  max-width:620px;   /* control width */
		  width: 100%;
		}

		.branch-select select {
		  padding: 6px 10px;
		  font-size: 13px;
		  border: 1px solid #cbd5e1;
		  border-radius: 5px;
		  outline: none;
		  width: 100%;
		}

		.branch-select select:focus {
		  border-color: #059669;
		}
		/* Footer */
				.footer {
				  display: flex;
				  justify-content: space-between;
				  margin-top: 20px;
				}

				.btn {
				  padding: 8px 16px;
				  border-radius: 6px;
				  border: none;
				  cursor: pointer;
				  font-size: 13px;
				}

				.prev-btn {
				  background: #e2e8f0;
				}

				.next-btn {
				  background: #2563eb;
				  color: white;
				}

				.next-btn:disabled {
				  background: #94a3b8;
				  cursor: not-allowed;
				}

      `}</style>

			{alertData && (
				<div className={`custom-alert ${alertData.type}`}>
					<span className="alert-icon">
						{alertData.type === "success" ? "✔" : "❗"}
					</span>
					{alertData.message}
				</div>
			)}

			<div className="title">
				Educational Qualification
			</div>

			{(selectedProgramcode === "02" || selectedProgramcode === "2") && (
				<>
					<div className="question-row">

						<div className="question">
							Are you Appearing in Final Semester of Diploma?
						</div>

						<div className="radio-group">
							<label>
								<input
									type="radio"
									name="appearingFinalSemester"
									value="YES"
									checked={educationData.appearingFinalSemester === "YES"}
									onChange={handleChange}
									disabled={!canEdit}
								/>
								Yes
							</label>

							<label>
								<input
									type="radio"
									name="appearingFinalSemester"
									value="NO"
									checked={educationData.appearingFinalSemester === "NO"}
									onChange={handleChange}
									disabled={!canEdit}
								/>
								No
							</label>
						</div>

					</div>

					{/* ✅ SHOW TABLE ONLY IF NO */}
					{educationData.appearingFinalSemester === "NO" && (
						<div className="table-box">
							<table>
								<thead>
									<tr>
										<th>Examination Passed</th>
										<th>Year of Passing</th>
										<th>Percentage (%)</th>
									</tr>
								</thead>

								<tbody>
									<tr>
										<td>
											<input
												name="exam"
												value="Diploma"
												readOnly
												style={{
													backgroundColor: "#f5f5f5",
													cursor: "not-allowed"
												}}
											/>
										</td>

										<td>
											<input
												name="yearOfPassing"
												value={educationData.yearOfPassing}
												onChange={handleChange}
												maxLength={4}
												placeholder="Enter Year"
												autoComplete="off"
												disabled={!canEdit}
											/>
										</td>

										<td>
											<input
												name="percentage"
												value={educationData.percentage}
												onChange={handleChange}
												placeholder="Enter %"
												autoComplete="off"
												disabled={!canEdit}
											/>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					)}

					<div className="branch-row">

						<div className="branch-label">
							Branch of Engineering applied for:
						</div>

						<div className="branch-select">
							<select
								name="branch"   // 🔥 IMPORTANT
								value={educationData.branch}
								onChange={handleChange}  // reuse same handler
								disabled={!canEdit}
							>
								<option value="0">[SELECT]</option>
								<option value="CHEMICAL ENGINEERING">1 - CHEMICAL ENGINEERING</option>
								<option value="CIVIL ENGINEERING">2 - CIVIL ENGINEERING</option>
								<option value="COMPUTER SCIENCE ENGINEERING">3 - COMPUTER SCIENCE ENGINEERING</option>
								<option value="ELECTRICAL ENGINEERING">4 - ELECTRICAL ENGINEERING</option>
								<option value="ELECTRONICS AND TELECOMMUNICATION ENGINEERING">5 - ELECTRONICS AND TELECOMMUNICATION ENGINEERING</option>
								<option value="INDUSTRIAL AND PRODUCTION ENGINEERING">6 - INDUSTRIAL AND PRODUCTION ENGINEERING</option>
								<option value="INSTRUMENTATION ENGINEERING">7 - INSTRUMENTATION ENGINEERING</option>
								<option value="MECHANICAL ENGINEERING">8 - MECHANICAL ENGINEERING</option>
								<option value="POWER ELECTRONICS & INSTRUMENTATION ENGINEERING">9 - POWER ELECTRONICS & INSTRUMENTATION ENGINEERING</option>
							</select>
						</div>

					</div>
					<hr />
					<div className="branch-row">

						<div className="branch-label">
							Candidates must have a Recognized Diploma of Minimum of 3 years duration from
							any Polytechnic Institution of Assam under the following:
						</div>

						<div className="branch-select">
							<select
								name="recognizediplomainstitution"   // 🔥 IMPORTANT
								value={educationData.recognizediplomainstitution}
								onChange={handleChange}  // reuse same handler
								disabled={!canEdit}
							>
								<option value="0">[SELECT]</option>
								<option value="STATE COUNCIL FOR TECHNICAL EDUCATION (SCTE), ASSAM">STATE COUNCIL FOR TECHNICAL EDUCATION (SCTE), ASSAM</option>
								<option value="CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING AND TECHNOLOGY (CIPET),GUWAHATI, ASSAM">CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING AND TECHNOLOGY (CIPET),GUWAHATI, ASSAM</option>
								<option value="ASSAM ENERGY INSTITUTE, SIVASAGAR">ASSAM ENERGY INSTITUTE, SIVASAGAR</option>
								<option value="CENTRAL INSTITUTE OF TECHNOLOGY (CIT), KOKRAJHAR">CENTRAL INSTITUTE OF TECHNOLOGY (CIT), KOKRAJHAR</option>
								<option value="NONE">NONE</option>
							</select>
						</div>

					</div>
				</>
			)}

			{(selectedProgramcode === "01" || selectedProgramcode === "1") && (
				<>
					<div className="question-row">

						<div className="question">
							Have you passed Mathematics as one of the subjects at 10+2 level or at Graduation?
						</div>

						<div className="radio-group">
							<label>
								<input
									type="radio"
									name="mathsPassed"
									value="YES"
									checked={educationData.mathsPassed === "YES"}
									onChange={handleChange}
									disabled={!canEdit}
								/>
								Yes
							</label>

							<label>
								<input
									type="radio"
									name="mathsPassed"
									value="NO"
									checked={educationData.mathsPassed === "NO"}
									onChange={handleChange}
									disabled={!canEdit}
								/>
								No
							</label>
						</div>

					</div>
					<div className="question-row">

						<div className="question">
							Are you Appearing in Final Semester of Graduation?
						</div>

						<div className="radio-group">
							<label>
								<input
									type="radio"
									name="appearingFinalGraduation"
									value="YES"
									checked={educationData.appearingFinalGraduation === "YES"}
									onChange={handleChange}
									disabled={!canEdit}
								/>
								Yes
							</label>

							<label>
								<input
									type="radio"
									name="appearingFinalGraduation"
									value="NO"
									checked={educationData.appearingFinalGraduation === "NO"}
									onChange={handleChange}
									disabled={!canEdit}
								/>
								No
							</label>
						</div>

					</div>

					{/* ✅ SHOW TABLE ONLY IF NO */}
					{educationData.appearingFinalGraduation && (
						<div className="table-box">
							<table>
								<thead>
									<tr>
										<th>Examination Passed</th>
										<th>
											{educationData.appearingFinalGraduation === "YES"
												? "Year of Appearing"
												: "Year of Passing"}
										</th>
										<th>Percentage (%)</th>
									</tr>
								</thead>

								<tbody>
									<tr>
										<td>
											<input
												name="examGraduation"
												value={
													educationData.appearingFinalGraduation === "NO"
														? "Graduation Final Semester"
														: "Graduation Fifth Semester"
												}
												readOnly
												style={{
													backgroundColor: "#f5f5f5",
													cursor: "not-allowed"
												}}
											/>
										</td>

										<td>
											<input
												name="yearOfPassingGraduation"
												value={educationData.yearOfPassingGraduation}
												onChange={handleChange}
												maxLength={4}
												placeholder="Enter Year"
												autoComplete="off"
												disabled={!canEdit}
											/>
										</td>

										<td>
											<input
												name="percentageGraduation"
												value={educationData.percentageGraduation}
												onChange={handleChange}
												placeholder="Enter %"
												autoComplete="off"
												disabled={!canEdit}
											/>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					)}

				</>
			)}

			<div className="footer">

				{/* Previous */}
				<button className="btn prev-btn" onClick={onPrev}>
					⬅ Previous
				</button>

				{/* Next */}
				<button
					className="btn next-btn"
					onClick={handleSubmit}
				>
					Next ➜
				</button>

			</div>
		</div>
	);
}

export default Education;